import apiClient from "./axios";

export const getImages = async (params = {}) => {
  const { data } = await apiClient.get("/images", { params });
  return data;
};

export const getImage = async (id) => {
  const { data } = await apiClient.get(`/images/${id}`);
  return data;
};

export const uploadImages = async (formData) => {

  const { data } = await apiClient.post("/images", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
};

export const deleteImage = async (id) => {
  const { data } = await apiClient.delete(`/images/${id}`);
  return data;
};

export const bulkDeleteImages = async (imageIds) => {
  const { data } = await apiClient.delete("/images/bulk-delete", {
    data: { image_ids: imageIds }
  });
  return data;
};

// Optional: If you want to update image details (not the file itself)
export const updateImage = async ({ id, ...imageData }) => {
  const { data } = await apiClient.patch(`/images/${id}`, imageData);
  return data;
};